import { render, staticRenderFns } from "./FormDatePicker.vue?vue&type=template&id=0b54652a&scoped=true&"
import script from "./FormDatePicker.vue?vue&type=script&lang=js&"
export * from "./FormDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./FormDatePicker.vue?vue&type=style&index=0&id=0b54652a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54652a",
  null
  
)

export default component.exports